import { gql } from '@apollo/client';
import { Dispatch } from '../components/architecture/frontend/index'
import { map, filter } from 'rxjs/operators'

import _ from 'lodash'

const fragment = `
  fragment CompanyData on Company {
    id
    name   
    code
    logo
  }
  `


const GET_COMPANY = gql`
  query company {
    company {
      ...CompanyData
    }
  }
  ${fragment},
`;

Dispatch.getState('user.email')
  .pipe(
    filter(e => !_.isNil(e))
  )
  .subscribe(e => {
      Dispatch.nextAction('Request.company', { type: 'query', query: GET_COMPANY, variables: { }, poll: process.env.REACT_APP_POLL_INTERVAL,  retry: process.env.REACT_APP_RETRY_INTERVAL })
  })

  Dispatch.getAction('Response.company')
  .pipe(
    filter(e => _.isNil(e.errors)),
    map(e => e.data.company )
  )
  .subscribe(e => Dispatch.nextState('company', e))